<template>
  <div>
    <div v-if="isLoading" class="text-center my-2">
      <b-spinner class="align-middle"></b-spinner>
      <strong class="ms-2">Cargando detalles...</strong>
    </div>
    <div v-else-if="detailedQuestions && detailedQuestions.length > 0">
      <PepQuestionDisplay
        v-for="(question_data, index) in detailedQuestions"
        :key="question_data.id"
        :question="question_data"
        :itemIndex="index"
        parentNumberString=""
      />
    </div>
    <div v-else class="text-center my-2">
      No hay preguntas y respuestas detalladas para esta declaración.
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import PepQuestionDisplay from "./PepQuestionDisplay.vue";

export default {
  name: "PepStatementRowDetails",

  components: {
    PepQuestionDisplay,
  },

  props: {
    statement: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      detailedQuestions: [],
    };
  },

  async mounted() {
    await this.fetchDetails();
  },

  methods: {
    ...mapActions(["getAllPepQuestionChildren"]),

    async fetchDetails() {
      if (
        !this.statement ||
        !this.statement.questions ||
        this.statement.questions.length === 0
      ) {
        this.detailedQuestions = [];
        return;
      }
      this.isLoading = true;

      const processedTopLevelQuestions = await Promise.all(
        this.statement.questions.map(async (topLevelQuestion) => {
          const descendants = await this._fetchAndShapeDescendants(
            topLevelQuestion.id
          );
          return {
            ...topLevelQuestion,
            childrenQuestions: descendants,
          };
        })
      );
      this.detailedQuestions = processedTopLevelQuestions;
      this.isLoading = false;
    },

    async _fetchAndShapeDescendants(questionId) {
      const childrenResponse = await this.getAllPepQuestionChildren({
        questionId,
      });
      if (childrenResponse.isError || !childrenResponse.data) {
        console.error(
          "Error fetching children for question ID:",
          questionId,
          childrenResponse.message
        );
        return [];
      }

      return await Promise.all(
        childrenResponse.data.map(async (rawChild) => {
          const grandChildren = await this._fetchAndShapeDescendants(
            rawChild.id
          );
          return {
            id: rawChild.id,
            name: rawChild.name,
            fieldNameCargo: rawChild.fieldNameCargo,
            fieldNameDate: rawChild.fieldNameDate,
            answer: {
              id: rawChild.answerId,
              isCorrect: rawChild.answerIsCorrect,
              questionSocieties: rawChild.societies || [],
            },
            childrenQuestions: grandChildren,
          };
        })
      );
    },
  },
};
</script>
